import { AppContext } from "../contexts/app-context";
import { Injectable } from "@angular/core";
import { PageView } from "../models/domains/features/page-view";

@Injectable({ providedIn: "root" })
export class FeatureViewService {
  private pageViews: Array<PageView> = [];

  constructor(private context: AppContext) {}

  activePageView(pageView: string) {
    const found = this.pageViews.find((pv) => pv.getName() === pageView);

    if (!!found) {
      this.context.setActivePageView(found.getName());
    }
  }

  getActivePageView(): string {
    return this.context.getActivePageView();
  }

  registerPageView(pageView: PageView) {
    this.pageViews.push(pageView);
  }

  isRegister(): boolean {
    return this.pageViews.length > 0;
  }

  activeFeatureView(featureView: string, pageView: string) {
    const foundPageView = this.pageViews.find((pv) => pv.getName() === pageView);

    if (!!foundPageView) {
      const foundFeatureView = foundPageView.findFeatureByName(featureView);

      if (!!foundFeatureView) {
        this.context.setActiveFeatureView(foundFeatureView.getName());
      }
    }
  }

  getActiveFeatureView(): string {
    return this.context.getActiveFeatureView();
  }
}
